(() => {
  'use strict'

  document.documentElement.dataset.hllAdsAttribution = 'loaded'

  const STORAGE_KEY = 'hll_ads_attribution_v1'
  const MAX_AGE_MS = 90 * 24 * 60 * 60 * 1000
  const SOURCE_PARAMS = ['gclid', 'gbraid', 'wbraid', 'utm_campaign', 'utm_source', 'utm_medium']
  const FORM_FIELDS = {
    attributionId: 'Ads attributie ID',
    gclid: 'Google Click ID',
    gbraid: 'Google Braid ID',
    wbraid: 'Google Web Braid ID',
    utm_campaign: 'Ads campagne ID',
    utm_source: 'Ads bron',
    utm_medium: 'Ads medium',
    landingUrl: 'Ads landing URL'
  }
  const NATIVE_FIELDS = {
    attributionId: 'ads_attribution_id',
    gclid: 'gclid',
    gbraid: 'gbraid',
    wbraid: 'wbraid',
    utm_campaign: 'ads_campaign_id',
    utm_source: 'ads_source',
    utm_medium: 'ads_medium',
    landingUrl: 'ads_landing_url'
  }

  function newAttributionId() {
    return `hll-${Date.now()}-${Math.random().toString(36).slice(2)}`
  }

  function marketingAllowed() {
    const privacy = window.Shopify && window.Shopify.customerPrivacy
    return Boolean(privacy && typeof privacy.marketingAllowed === 'function' && privacy.marketingAllowed())
  }

  function readStored() {
    try {
      const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null')
      if (!value || !value.capturedAt || Date.now() - value.capturedAt > MAX_AGE_MS) return null
      return value
    } catch (_) {
      return null
    }
  }

  function cookieGclid() {
    const match = document.cookie.match(/(?:^|;\s*)_gcl_aw=([^;]+)/)
    if (!match) return ''
    const parts = decodeURIComponent(match[1]).split('.')
    return parts.length >= 3 ? parts.slice(2).join('.') : ''
  }

  function capture() {
    if (!marketingAllowed()) return null
    const query = new URLSearchParams(location.search)
    const current = readStored()
    const hasAdSignal = SOURCE_PARAMS.some((name) => query.get(name))
    if (current && !hasAdSignal) return current
    const fallbackGclid = cookieGclid()
    if (!current && !hasAdSignal && !fallbackGclid) return null

    const isSameTouch = current && SOURCE_PARAMS.every((name) => {
      const candidate = query.get(name)
      return !candidate || candidate === current[name]
    })
    const value = isSameTouch ? current : {
      attributionId: newAttributionId(),
      capturedAt: Date.now(),
      landingUrl: location.href.slice(0, 2048)
    }
    for (const name of SOURCE_PARAMS) {
      const candidate = query.get(name)
      if (candidate) value[name] = candidate.slice(0, 512)
    }
    if (!value.gclid && fallbackGclid) value.gclid = fallbackGclid.slice(0, 512)
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(value))
    } catch (_) {
      // The form remains usable when storage is blocked; only attribution is absent.
    }
    return value
  }

  function validClickIdentity(attribution) {
    const supplied = ['gclid', 'gbraid', 'wbraid'].filter((name) => attribution && attribution[name])
    return supplied.length <= 1
  }

  function decoratePortalLinks(attribution) {
    if (!attribution || !validClickIdentity(attribution)) return
    document.querySelectorAll('a[href]').forEach((link) => {
      try {
        const url = new URL(link.href, location.origin)
        if (url.protocol !== 'https:' || url.hostname !== 'app.laserlokaal.nl') return
        const portalFields = {
          hll_aid: 'attributionId',
          gclid: 'gclid',
          gbraid: 'gbraid',
          wbraid: 'wbraid',
          utm_campaign: 'utm_campaign',
          utm_source: 'utm_source',
          utm_medium: 'utm_medium'
        }
        Object.entries(portalFields).forEach(([target, source]) => {
          if (attribution[source]) url.searchParams.set(target, attribution[source])
        })
        link.href = url.toString()
      } catch (_) {
        // Invalid links remain unchanged.
      }
    })
  }

  function attributedFormUrl(baseUrl, attribution) {
    if (!attribution) return baseUrl
    try {
      const url = new URL(baseUrl)
      if (url.protocol !== 'https:' || !url.hostname.endsWith('.fibery.io')) return baseUrl
      for (const [source, field] of Object.entries(FORM_FIELDS)) {
        if (attribution[source]) url.searchParams.set(field, attribution[source])
      }
      return url.toString()
    } catch (_) {
      return baseUrl
    }
  }

  function fillNativeForm(form, attribution) {
    if (!attribution) return
    let filled = 0
    for (const [source, fieldName] of Object.entries(NATIVE_FIELDS)) {
      const field = form.querySelector(`[name="${fieldName}"]`)
      if (field) {
        field.value = attribution[source] || ''
        field.setAttribute('value', attribution[source] || '')
        if (field.value) filled += 1
      }
    }
    document.documentElement.dataset.hllAdsFilledFields = String(filled)
  }

  function initializeForms() {
    const attribution = capture()
    document.documentElement.dataset.hllAdsAttribution = attribution ? 'attributed' : 'organic'
    document.querySelectorAll('[data-hll-fibery-form]').forEach((frame) => {
      const baseUrl = frame.dataset.baseUrl || frame.src
      const url = attributedFormUrl(baseUrl, attribution)
      frame.src = url
      const fallback = frame.closest('.ll-fibery-form__frame')?.querySelector('[data-hll-fibery-fallback]')
      if (fallback) fallback.href = url
    })
    document.querySelectorAll('#hll-form').forEach((form) => fillNativeForm(form, attribution))
    decoratePortalLinks(attribution)
    document.documentElement.dataset.hllAdsFormCount = String(document.querySelectorAll('#hll-form').length)
  }

  document.addEventListener('visitorConsentCollected', initializeForms)

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeForms, { once: true })
  } else {
    initializeForms()
  }
})()
